import { render, staticRenderFns } from "./dropdown_suggester.vue?vue&type=template&id=ec614270"
import script from "./dropdown_suggester.vue?vue&type=script&lang=js"
export * from "./dropdown_suggester.vue?vue&type=script&lang=js"
import style0 from "./dropdown_suggester.vue?vue&type=style&index=0&id=ec614270&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports